import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as CategoryList from 'types/_general/Store/IngredientCategoryList';

const rb = new ReducerBuilder<CategoryList.Type>();

export const createIngredientCategoriesLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'IngredientCategories/LoadedFromBackend'
);

export const ingredientCategoriesReducer = rb.createReducer();
